/* eslint-disable @nx/enforce-module-boundaries */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PageTitleComponent, UiKitModule } from '@serviceplan/ui-kit';
import { ClientAssetsModule, CollectionsModule } from '@thehubz/client/assets-module';
import { ClientCoreModule, CommonUtilityLib, MatComponentsModule } from '@thehubz/client/core';
import { ClientLeftNavModule } from '@thehubz/client/left-nav';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { LayoutComponent } from './components/layout.component';
import { LoginOptionPopupComponent } from './components/login-option-popup/login-option-popup';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { RoutingModule } from './routing.module';

@NgModule({
  imports: [
    CommonModule,
    RoutingModule,
    ClientCoreModule,
    MatComponentsModule,
    UiKitModule,
    ClientLeftNavModule,
    ClientAssetsModule,
    CollectionsModule,
    PageTitleComponent,
    FooterComponent,
  ],
  declarations: [LayoutComponent, HeaderComponent, WelcomeComponent, LoginOptionPopupComponent],
  providers: [CommonUtilityLib],
  exports: [FooterComponent],
})
export class CustomLayoutModule {}
